import { Checkbox, Flex, Typography } from "antd";
import styled from "styled-components";

export const StyledCheckbox = styled(Checkbox)`
    && {
        border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};
        padding-bottom: 8px;
        width: 100%;
        -webkit-tap-highlight-color: transparent;

        .ant-checkbox-inner {
            width: 32px;
            height: 32px;
            border-radius: 6px;
            border-width: 2px;

            &::after {
                inset-inline-start: 28%;
                top: 48%;
                width: 8.5px;
                height: 16px;
            }
        }

        .ant-checkbox-checked .ant-checkbox-inner {
            background-color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
        }

        .ant-checkbox-label {
            padding: 0;
            flex-grow: 1;
            padding-left: 16px;
        }
    }
`;

export const StyledContentBody = styled(Flex)`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    width: 100%;
    gap: 16px;
`;

export const StyledContentList = styled(Flex)`
    height: 100%;
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
    min-height: 0;
`;

export const StyledContentListContainer = styled(Flex)`
    height: 100%;
    overflow: hidden;
`;

export const StyledProductBarcode = styled(Typography.Text)`
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    color: ${({ theme }) => theme.secondaryTypographyColor};
    border-bottom: 1px dashed ${({ theme }) => theme.secondaryTypographyColor};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    position: relative;
    z-index: 2;
`;

export const StyledProductInfoText = styled(Typography.Text)`
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    color: ${({ theme }) => theme.secondaryTypographyColor};
`;

export const StyledRemainingCount = styled.span`
    color: ${({ theme }) => theme.additionalTypographyColor};
`;
